import type { ReactNode } from "react";
import { MessageCircle } from "lucide-react";

import { WHATSAPP_COUPON, whatsappHref } from "@/lib/business";
import { cn } from "@/lib/utils";

/**
 * O chat simulado foi desativado: todos os botões de WhatsApp abrem direto a
 * conversa com a Chavel, com uma mensagem pronta contendo o cupom de desconto.
 */
export function WhatsAppChatProvider({ children }: { children: ReactNode }) {
  return (
    <>
      {children}

      <div className="fixed bottom-5 right-5 z-50">
        <span className="pointer-events-none absolute inset-0 rounded-full bg-whatsapp opacity-70 motion-safe:animate-wa-ring" />
        <span className="pointer-events-none absolute inset-0 rounded-full bg-whatsapp opacity-50 motion-safe:animate-wa-ring [animation-delay:.9s]" />
        <a
          href={whatsappHref}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Falar no WhatsApp com a Chavel e usar o cupom ${WHATSAPP_COUPON}`}
          className="relative flex h-16 w-16 items-center justify-center rounded-full bg-whatsapp text-whatsapp-foreground shadow-[0_10px_30px_-6px_rgba(0,0,0,.45)] ring-4 ring-whatsapp/25 transition-transform hover:scale-110 motion-safe:animate-wa-pulse"
        >
          <MessageCircle className="h-8 w-8" />
        </a>
      </div>
    </>
  );
}

export function WhatsAppButton({
  children = "Falar no WhatsApp",
  className,
  variant = "primary",
}: {
  children?: ReactNode;
  className?: string;
  variant?: "primary" | "outline" | "gold";
}) {
  return (
    <a
      href={whatsappHref}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold transition-colors",
        variant === "primary" && "bg-whatsapp text-whatsapp-foreground hover:opacity-90",
        variant === "gold" && "bg-gold text-gold-foreground hover:opacity-90",
        variant === "outline" && "border border-primary-foreground/40 text-primary-foreground hover:bg-primary-foreground/10",
        className,
      )}
    >
      <MessageCircle className="h-4 w-4" />
      {children}
    </a>
  );
}
